/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Resolution data
 * @export
 * @interface ResolveWeaknessRequest
 */
export interface ResolveWeaknessRequest {
    /**
     * 
     * @type {string}
     * @memberof ResolveWeaknessRequest
     */
    assetId?: string;
    /**
     * 
     * @type {string}
     * @memberof ResolveWeaknessRequest
     */
    resolutionMethod?: ResolveWeaknessRequestResolutionMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof ResolveWeaknessRequest
     */
    notes?: string;
}


/**
 * @export
 */
export const ResolveWeaknessRequestResolutionMethodEnum = {
    Patched: 'PATCHED',
    ConfigurationFixed: 'CONFIGURATION_FIXED',
    WorkaroundApplied: 'WORKAROUND_APPLIED',
    AssetDecommissioned: 'ASSET_DECOMMISSIONED',
    FalsePositive: 'FALSE_POSITIVE',
    PolicyImplemented: 'POLICY_IMPLEMENTED',
    InsuranceObtained: 'INSURANCE_OBTAINED',
    RiskAccepted: 'RISK_ACCEPTED',
    Other: 'OTHER'
} as const;
export type ResolveWeaknessRequestResolutionMethodEnum = typeof ResolveWeaknessRequestResolutionMethodEnum[keyof typeof ResolveWeaknessRequestResolutionMethodEnum];


/**
 * Check if a given object implements the ResolveWeaknessRequest interface.
 */
export function instanceOfResolveWeaknessRequest(value: object): value is ResolveWeaknessRequest {
    return true;
}

export function ResolveWeaknessRequestFromJSON(json: any): ResolveWeaknessRequest {
    return ResolveWeaknessRequestFromJSONTyped(json, false);
}

export function ResolveWeaknessRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResolveWeaknessRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'assetId': json['assetId'] == null ? undefined : json['assetId'],
        'resolutionMethod': json['resolutionMethod'] == null ? undefined : json['resolutionMethod'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function ResolveWeaknessRequestToJSON(json: any): ResolveWeaknessRequest {
    return ResolveWeaknessRequestToJSONTyped(json, false);
}

export function ResolveWeaknessRequestToJSONTyped(value?: ResolveWeaknessRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assetId': value['assetId'],
        'resolutionMethod': value['resolutionMethod'],
        'notes': value['notes'],
    };
}

